<script setup lang="ts">
import { computed, markRaw, ref } from 'vue'

import IconSettingImage from '@/components/atoms/icons/IconSettingImage.vue'
import IconSettingLayout from '@/components/atoms/icons/IconSettingLayout.vue'
import SettingImageSelector from '@/components/beta-editor/settings/controls/BetaSettingImageSelector.vue'
import SettingWidth from '@/components/atoms/SettingWidth.vue'
import EditorSidebarLayout from '@/components/layouts/EditorSidebarLayout.vue'
import SettingsLayout from '@/components/layouts/SettingsLayout.vue'
import { useEditorBetaStore } from '@/stores/editor/beta'

const betaStore = useEditorBetaStore()
const elementForEdit = computed(() => betaStore.elementForEdit)
const settings = ref([
    { id: 1, name: 'image', icon: markRaw(IconSettingImage) },
    { id: 2, name: 'layout', icon: markRaw(IconSettingLayout) },
])

const ensureFrameContent = () => {
    if (!elementForEdit.value) return

    elementForEdit.value.frameContent = {
        ...(elementForEdit.value.frameContent ?? {}),
    }
}

const onChangeWidth = (event: any) => {
    if (!elementForEdit.value) return

    if (event.target === 'desktop') elementForEdit.value.grid = event.value
    if (event.target === 'mobile') elementForEdit.value.gridMobile = event.value

    betaStore.updateElementForEdit()
}

const onChangeImage = (key: 'afterPicture' | 'beforePicture', event: any) => {
    if (!elementForEdit.value) return
    ensureFrameContent()

    elementForEdit.value.frameContent = {
        ...elementForEdit.value.frameContent,
        [key]: event.value?.content ?? null,
    }

    betaStore.updateElementForEdit()
}
</script>

<template>
    <editor-sidebar-layout v-if="elementForEdit" :settings="settings">
        <template #image>
            <settings-layout name="Configurações da Imagem" :default-open="true">
                <setting-image-selector
                    label="Imagem Esquerda"
                    :value="elementForEdit.frameContent?.afterPicture"
                    @change="(event: any) => onChangeImage('afterPicture', event)"
                />

                <setting-image-selector
                    label="Imagem Direita"
                    :value="elementForEdit.frameContent?.beforePicture"
                    @change="(event: any) => onChangeImage('beforePicture', event)"
                />
            </settings-layout>
        </template>

        <template #layout>
            <settings-layout name="Configurações do Conteúdo" :default-open="true">
                <setting-width
                    label="Largura"
                    :value="elementForEdit.grid"
                    :value-mobile="elementForEdit.gridMobile"
                    :values-permission-desktop="[4, 6, 12]"
                    :values-permission-mobile="[4, 6, 12]"
                    @change="onChangeWidth"
                />
            </settings-layout>
        </template>
    </editor-sidebar-layout>
</template>
